export const SOCKET_RESERVE_CREATED = 'SOCKET_RESERVE_CREATED';
export const SOCKET_RESERVE_CONFIRMATION = 'SOCKET_RESERVE_CONFIRMATION';
export const SOCKET_RECONNECT = 'SOCKET_RECONNECT';
export const SET_SOCKET_CONNECT_STATUS = 'SET_SOCKET_CONNECT_STATUS';
export const SOCKET_SEND_MESSAGE = 'SOCKET_SEND_MESSAGE';

export const SOCKET_SUBSCRIBE_MESSENGER_AUTH = 'SOCKET_SUBSCRIBE_MESSENGER_AUTH';
export const SOCKET_UNSUBSCRIBE_MESSENGER_AUTH = 'SOCKET_UNSUBSCRIBE_MESSENGER_AUTH';
